export const paths = {
  LOGIN_PATH: "/login",
  REGISTER_PATH: "/register",
  APPLICATION_PATH: "/",
  HOME_PATH: "/home",
  ADMINISTRATION: "/administration",
  KNOWLEDGE_MANAGMENT: "/knowledgeManagment",
  KNOWLEDGE_ITEM: "/knowledgeItem",
  KNOWLEDGE: "/knowledge",
  MESSAGE_LOG_TYPE: "/messageLogType",
  CLASS_DEFINITION: "/classDefinition",
  ROLES: "/roleTypes",
  LIFE_CYCLE: "/lifeCycle",
  EXTENSION: "/extension",
  USERS: "/users",
  USERROLES: "/userRoles",
  ADVANCED_SEARCH: "/advancedSearch",
  CLASSIFICATIONS: "/classification",
  DETAIL: "/detail",
  INVOLVEMENTROLETYPES: "/involvementRoleTypes",
  INVOLVEMENTROLETYPE: "/involvementRoleType",
  OPERATIONS: "/operations",
  INVOLVEMENTROLES: "/involvementRoles"
};
